<template>
  <div class="grid-view">
    <div class="main-content">
      <div class="section">
        <el-form :inline="true" label-width="75px" label-position="left">
          <div class="app-main-inner-row" style="padding-bottom: 0;">
            <div style="width: 1000px;">
              <div class="el-form-item-wrapper">
                <el-form-item :label="$t('Payment.applicationNo')">
                  <el-input
                    v-model="billPayment.billPaymentNo"
                    no="1"
                    disabled="disabled"
                    style="width: 170px;"
                  />
                </el-form-item>
                <el-form-item :label="$t('Payment.status')" label-width="50px">
                  <span v-if="billPayment.state === 0">{{ $t('CargoMsg.Cargo_NoSubmit_SR') }}</span>
                  <span v-if="billPayment.state === 1 || billPayment.state === 2">{{ $t('CargoMsg.Cargo_AwaitApproval_SR') }}</span>
                  <span v-if="billPayment.state === 3">{{ $t('CargoMsg.Cargo_Approved_SR') }}</span>
                </el-form-item>
              </div>
              <div class="el-form-item-wrapper">
                <el-form-item :label="$t('Payment.settleAccountsTo')">
                  <cargo-advance-select
                    no="2"
                    filterable
                    :select-type="selectTypeNames.basic_data_Company"
                    :method-params="{customer:true}"
                    :default-value="Number(billPayment.accountId)||''"
                    style="width:100%;"
                    tag-name="chineseName"
                    disabled
                    @parentCallBack="billPaymentAccountCallBack"
                  />
                </el-form-item>
                <el-form-item label-width="0">
                  <el-checkbox v-model="agentChecked" no="3" :disabled="canEditAgent" true-label="1" false-label="0" @change="cbSettlementAgentChangeHandler">{{ $t('Payment.bySettlementAgent') }}</el-checkbox>
                  <el-select v-model="billPayment.settlementAgentId" no="4" :disabled="canEditAgentBox" style="margin-left:10px;width:170px;" @change="ddlSettlementAgentChangeHandler">
                    <el-option
                      v-for="(item,index) in settlementAgentList"
                      :key="index"
                      :label="$store.getters.language === 'zh'?item.chineseName:item.englishName"
                      :value="Number(item.cmpIdx)||''"
                    />
                  </el-select>
                </el-form-item>
              </div>
              <div class="el-form-item-wrapper">
                <el-form-item :label="$t('Payment.businessType')">
                  <el-checkbox-group v-model="ywTypeList" no="5" disabled>
                    <el-checkbox no="6" label="SE">{{ $t('Payment.oceanExport') }}</el-checkbox>
                    <el-checkbox no="7" label="SI">{{ $t('Payment.oceanImport') }}</el-checkbox>
                    <el-checkbox no="8" label="AE">{{ $t('Payment.airExport') }}</el-checkbox>
                    <el-checkbox no="9" label="AI">{{ $t('Payment.airImport') }}</el-checkbox>
                  </el-checkbox-group>
                </el-form-item>
              </div>
              <div class="el-form-item-wrapper">
                <el-form-item :label="$t('Payment.currency')">
                  <cargo-advance-select
                    no="10"
                    style="width: 100px"
                    filterable
                    :select-type="selectTypeNames.basic_data_Currency"
                    :default-value="billPayment.currency||''"
                    :disabled="saveDisabled"
                    @parentCallBack="currencyExchanged"
                  />
                </el-form-item>
                <el-form-item :label="rateTitle" label-width="70px">
                  <num-input
                    v-model="billPayment.rate"
                    no="11"
                    style="width: 130px;"
                    :max="999999999.000000"
                    :min="0.000001"
                    :precision="8"
                    :truncated-precision="ratePrecision"
                    :disabled="saveDisabled"
                    @change="rateChangeHandler"
                  />
                </el-form-item>
                <el-form-item :label="$t('Payment.amount')" label-width="40px">
                  <el-input
                    v-model="billPayment.amount"
                    no="12"
                    disabled
                    style="width: 100px;"
                  />
                </el-form-item>
              </div>
              <div class="el-form-item-wrapper">
                <el-form-item :label="$t('Payment.paymentPeriod')">
                  <el-date-picker
                    v-model="billPayment.deadline"
                    no="13"
                    type="date"
                    clearable
                    style="width: 150px;"
                    :disabled="saveDisabled"
                  />
                </el-form-item>
                <el-form-item :label="$t('Payment.methodOfPayment')">
                  <el-select v-model="billPayment.payType" no="14" style="width: 150px" :disabled="saveDisabled">
                    <el-option
                      v-for="(item,index) in receive_types"
                      :key="index"
                      :label="$store.getters.language === 'zh'?item.chineseName:item.englishName"
                      :value="Number(item.code)"
                    />
                  </el-select>
                </el-form-item>
              </div>
              <div class="el-form-item-wrapper">
                <el-form-item :label="$t('Payment.bankOfDeposit')">
                  <cargo-advance-select
                    no="15"
                    filterable
                    :select-type="selectTypeNames.static_data_TitleBank"
                    :default-value="buyerBankUuid"
                    :cache="false"
                    :static-options="titleBankArray"
                    tag-value="uuid"
                    tag-name="bank"
                    style="width:170px;"
                    :headers="['币种', '银行名称']"
                    :fields="['currency', 'bank']"
                    :disabled="saveDisabled"
                    @parentCallBack="getBankCusFromChild"
                  />
                </el-form-item>
                <el-form-item :label="$t('Payment.bankAccount')">
                  <el-input
                    v-model="billPayment.buyerBankAccount"
                    no="16"
                    style="width: 150px;"
                    :disabled="saveDisabled"
                  />
                </el-form-item>
              </div>
              <div class="el-form-item-wrapper">
                <el-form-item :label="$t('Payment.applicant')">
                  <cargo-advance-select
                    no="17"
                    :actionable-option="item=>item.active"
                    :select-type="selectTypeNames.basic_data_User"
                    :url="URL.sys.getUsersByPrivilegeDetail"
                    :cache="false"
                    :method-params="{officeId:$store.getters.currentOfficeId}"
                    filterable
                    :default-value="Number(billPayment.inputBy)||''"
                    style="width:150px;"
                    disabled
                    @parentCallBack="item=>billPayment.inputBy=item.chineseName"
                  />
                </el-form-item>
                <el-form-item :label="$t('Payment.dateOfApplication')">
                  <el-date-picker
                    v-model="billPayment.inputDate"
                    no="18"
                    type="date"
                    clearable
                    style="width: 150px;"
                    :disabled="saveDisabled"
                  />
                </el-form-item>
              </div>
              <div class="el-form-item-wrapper">
                <el-form-item :label="$t('Payment.totalCurrency')">
                  <div style="width: 150px;">
                    <span>{{ billPayment.currencyAmount }}</span>
                  </div>
                </el-form-item>
                <el-form-item v-show="openSapConfig" :label="$t('Payment.settleDepartmentPrefix')">
                  <cargo-advance-select
                    no="19"
                    :select-type="selectTypeNames.basic_data_Department_All"
                    :method-params="{officeUuid:$store.getters.currentOfficeUuid,clearing:true}"
                    filterable
                    :default-value="billPayment.settleDepartmentPrefix"
                    tag-name="chineseName"
                    tag-value="jobNoPrefix"
                    style="width:150px;"
                    :disabled="saveDisabled"
                    @parentCallBack="item=>billPayment.settleDepartmentPrefix=item.jobNoPrefix"
                  />
                </el-form-item>
              </div>
            </div>
            <div style="width: 290px;">
              <div class="el-form-item-wrapper">
                <el-form-item label-width="0">
                  <span style="font-weight: bold;color:darkred;font-size: 14px;">{{ $t('Payment.couldNotSearhWriteOffJobFromThisWindow') }}</span>
                </el-form-item>
              </div>
              <div class="el-form-item-wrapper">
                <el-form-item :label="$t('Payment.remarks')" label-width="100px" class="custom-textarea">
                  <el-input v-model="billPayment.remark" no="20" type="textarea" :rows="12" style="width:290px;" />
                </el-form-item>
              </div>
            </div>
          </div>
        </el-form>
      </div>
      <div class="section grid-wrapper">
        <cargo-ag-grid
          slot="left"
          :show-side-bar="false"
          :grid-options="gridOptions"
          :column-defs="columnDefs"
          :row-data="rowData"
          style="width:100%;height:200px;"
        />
      </div>
      <div class="section">
        <span v-if="innerParamsFinal === 0" style="position: absolute;">
          <el-button no="21" type="primary" style="margin-right: 5px" @click="addCharge">{{ $t('Payment.addCharge') }}</el-button>
          <el-button no="22" type="primary" @click="removeCahrge">{{ $t('Payment.removeCharge') }}</el-button>
        </span>
        <span style="float:right;">
          <span v-show="innerParamsFinal === -1" style="margin-right: 0;">
            <el-button no="23" type="primary" @click="toPreStep">上一步</el-button>
          </span>
          <el-button no="24" style="float: right; margin-left: 5px" @click="cancel(0)">{{ $t('CargoMsg.Cargo_Cancel') }}</el-button>
          <el-button no="25" type="primary" style="float: right; " :disabled="saveDisabled" @click="doSave">{{ $t('CargoMsg.Cargo_Save') }}</el-button>
          <el-button v-show="innerParamsFinal === 0" no="26" :disabled="canSendWeaver" type="primary" style="float: right; " @click="commit">{{ $t('Payment.sendWeaver') }}</el-button>
          <el-button v-if="billPayment.uuid" no="27" type="primary" style="float: right;" @click="toPrint">{{ $t('Payment.print') }}</el-button>
        </span>
      </div>
    </div>
    <!-- 创建付款申请 选择费用-->
    <join-charge-dialog
      v-if="joinCharge.visible"
      :visible.sync="joinCharge.visible"
      :default-conditions="joinCharge.addChargeCondition"
      @leavePage="cancel(0)"
      @addChargeCallBackEvent="addChargeCallBackEvent"
    />
    <!-- 打印报表对话框 -->
    <cargo-template-selector-dialog
      :visible.sync="templateSelectorDialog.visible"
      :ctx="templateSelectorDialog.cxt"
      :category="templateSelectorDialog.category"
      :data="templateSelectorDialog.data"
      :context="context"
      :pre-print-callback="prePrintCallback"
      :printed-callback="printedCallback"
      :v2-check-callback="v2CheckCallback"
    />
  </div>
</template>

<script>
import { DocumentManage } from '@/utils/commonUtil'
import cargoTemplateSelectorDialog from '@/components/Cargo/Common/cargoTemplateSelectorDialog'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import { queryBillPaymentDetail, createBillPayment, updateBillPayment, batchUpdateBilPaymentStatePrintMsg } from '@/api/clearing/billPayment.js'
import * as ClearingConstants from '@/class/cargo/model/parameters/ClearingConstants'
import URL from '@/api/urlTranslator'
import { getGridSelected } from '@/utils/agGrid'
import ColumnUtils from '@/utils/ColumnUtils'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants.js'
import * as RateUtil from '@/class/cargo/model/utils/RateUtil'
import * as NumberUtils from '@/utils/NumberUtils'
import { SecurityUtil } from '@/class/cargo/model/utils/SecurityUtil'
import { Company } from '@/class/model/mdm/Company'
import { getSettlementAgentsByCmpIdx } from '@/api/company'
import { allTitleBanksByCmpIdx } from '@/api/partner/titleBank'
import { cacheName, cache } from '@/utils/cacheManager'
import joinChargeDialog from '@/components/Cargo/Act/joinChargeDialog'
import lodash from 'lodash'
import { BillPayment } from '@/class/model/act/BillPayment'
import * as index from '@/utils/index'
import DateUtils from '@/utils/dateUtils'
import ChargeUtils from '@/class/cargo/model/utils/ChargeUtils'
import { CurrencyUtil } from '@/class/cargo/model/utils/CurrencyUtil'
import NumInput from '@/components/Cargo/Common/NumInput'

/**
 * 包含运行时用到的基础数据
 */
class Context {
  /**
   * @param {Object} parent 父级Context
   */
  constructor(parent) {
    this.parent = parent
    this.userList = null
    this.companyList = null
    this.seaPortList = null
    this.regionList = null
    this.rowDefaultValDic = null
    this.opDepartment = null
    this.invisibleFormSet = new Set() // 不可见的表单集合（在页面中看不到，但被联动修改了的实体对象）
    this.config = null
    cache.load(cacheName.CONFIG).then(() => {
      this.config = cache.config
    })
  }
  get loading() {
    return this.parent.loading
  }
  set loading(loading) {
    this.parent.loading = loading
  }
  get user() {
    return this.parent.user
  }
  set user(user) {
    this.parent.user = user
  }
  get officeList() {
    return this.parent.officeList
  }
  set officeList(officeList) {
    this.parent.officeList = officeList
  }
  get office() {
    return this.parent.office
  }
  set office(office) {
    this.parent.office = office
  }
  get config() {
    return this.parent.config
  }
  set config(config) {
    this.parent.config = config
  }
  /**
   * 准备好数据
   */
  async prepareData() {
    await cache.load(cacheName.OFFICE, cacheName.CONFIG)
    this.office = cache.office
    this.config = cache.config
  }
}

export default {
  name: 'BillPaymentDialog',
  components: { cargoTemplateSelectorDialog, joinChargeDialog, cargoAdvanceSelect, NumInput },
  props: {
    openSapConfig: { type: Boolean, required: true },
    billPaymentUuid: { type: String, required: false },
    paramsFinal: { type: Number, required: true },
    paramsCharges: { type: Array, required: false },
    chargesDirty: { type: Boolean, required: true }, // 费用更新否
    billPaymentDirty: { type: Boolean, required: true }, // 付款申请更新否
    parentContext: { type: Object, required: true },
    location: { type: String, required: false }
  },
  data() {
    return {
      canSendWeaver: false, // 发送云平台按钮可用
      saveDisabled: true, // 保存按钮是否可用
      innerParamsFinal: this.paramsFinal,
      context: new Context(this.parentContext),
      // 收付方式源
      receive_types: ClearingConstants.AMOUNT_RECEIVE_TYPES,
      URL,
      innerVisible: this.visible,
      selectTypeNames: TYPE_NAMES,
      documentManage: new DocumentManage(),
      jobTypes: [],
      gridOptions: {
        rowSelection: 'multiple'
      },
      gridParams: {},
      gridApi: {},
      columnDefs: [],
      sideBarDefs: { toolPanels: ['columns', 'filter'], visible: false },
      rowData: [],
      // 请求详情body
      queryBody: {
        billPaymentUuid: 0
      },
      // 模板选择弹窗
      templateSelectorDialog: {
        visible: false,
        cxt: new BillPayment(),
        category: '',
        data: {}
      },
      prePrintCallback: null,
      printedCallback: null,
      v2CheckCallback: null,
      // 新增移除费用弹窗
      joinCharge: {
        visible: false,
        addChargeCondition: { // 点击加入费用按钮时传递的参数
          exceptKeys: [],
          hasBillPayment: -1,
          hasBilling: -1,
          oversea: -1,
          accountId: 0
        }
      },
      billPayment: {
        uuid: '',
        version: 0,
        billPaymentNo: '',
        state: 0,
        accountId: 0,
        settlementAgentId: '',
        se: false,
        si: false,
        ae: false,
        ai: false,
        currency: '',
        rate: 1.000000,
        amount: 0.00,
        ywType: 0,
        deadline: '',
        payType: 2,
        buyerBank: '',
        buyerBankAccount: '',
        inputBy: '',
        inputDate: '',
        settleDepartmentPrefix: '',
        remark: '',
        currencyAmount: '', // 分币种合计
        branchId: '',
        jobNo: '',
        costInvoiceNo: '',
        customerId: '',
        // isAdvance: '', // 是否垫付
        mapCharge: [],
        params: {},
        chargesAdded: [], // 更新时新增的费用
        chargesRemoved: [] // 更新时移除的费用
      },
      otherCurrencys: [],
      chargeRate: 1, // 合计汇率
      total: 0, // 合计
      company: {}, // 结算对象
      settlementAgent: {}, // 结算代理
      settlementAgentList: [], // 结算代理下拉框数据源
      canEditAgent: true, // 结算代理可编辑控制
      agentChecked: 0, // 是否选中使用结算代理 1是 0否
      canEditAgentBox: true, // 结算代理下拉框可编辑控制
      titleBankArray: [], // 银行账户
      chargesDirtyPage: false,
      billPaymentDirtyPage: false,
      checkedCharges: [], // 选中的费用
      ywTypeList: [], // 业务类型
      rateTitle: this.$t('Payment.exchangeRate'),
      buyerBankUuid: ''
    }
  },
  computed: {
    ratePrecision() {
      return CurrencyUtil.getCurrencyRateDigits(this.otherCurrencys.length > 0 ? this.otherCurrencys[0] : this.billPayment.currency)
    }
  },
  created() {
    this.columnDefs = [
      {
        headerName: '', checkboxSelection: true,
        sortable: false, suppressMenu: true, suppressSizeToFit: true, resizable: false,
        headerCheckboxSelection: true
      },
      { headerName: this.$t('Payment.businessNumber'), field: 'jobJobNo', width: 200,
        cellRenderer: params => {
          return params.value
          // const methodPath = this.documentManage.getPath('toSearchTemplate')
          // return `<a href="/" style="color:#0052cc;">${params.value}</a>
          //       <i class="el-icon-search" onclick="${methodPath}('${params.data.jobNo}')" style="color:#46a6ff;cursor:pointer"/>`
        } },
      { headerName: this.$t('Payment.consignationCompany'), field: 'jobCustomerId', width: 200,
        cellRenderer: (params) => {
          return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
        } },
      { headerName: this.$t('Payment.operation'), field: 'jobOp', width: 100,
        cellRenderer: params => {
          return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
        } },
      { headerName: this.$t('Payment.settlementCompany'), field: 'chargeAccountId', width: 200,
        cellRenderer: (params) => {
          return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
        } },
      { headerName: this.$t('Payment.businessDate'), field: 'jobBusinessDate', width: 150,
        cellRenderer: params => {
          return ColumnUtils.dateLabelFunc(params.value)
        }
      },
      { headerName: this.$t('Payment.chargeItem'), field: 'chargeChargeItemId', width: 150,
        cellRenderer: (params) => {
          return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_ChargeItem, 'itemId', params.value, 'zhName')
        } },
      { headerName: this.$t('Payment.currency'), field: 'chargeCurrency', width: 100 },
      { headerName: this.$t('Payment.paymentType'), field: 'chargeReceivable', width: 100,
        cellRenderer: (params) => {
          return ColumnUtils.chargeReceivableLabelFun(params.value)
        } },
      { headerName: this.$t('Payment.SONO'), field: 'jobSoNo', width: 150,
        valueFormatter: (params) => {
          return params.value.replace(/\n/g, ',')
        }
      },
      { headerName: this.$t('Payment.mbl'), field: 'jobMbl', width: 150 },
      { headerName: this.$t('Payment.taxIncludedPrice'), field: 'chargeAmount', width: 150,
        cellRenderer: (params) => {
          return index.formatNumberToThousands(params.value, 2)
        } },
      { headerName: this.$t('Payment.taxExcludedPrice'), field: 'chargeExcludingTaxAmount', width: 150,
        cellRenderer: (params) => {
          return index.formatNumberToThousands(params.value, 2)
        } },
      { headerName: this.$t('Payment.taxAmount'), field: 'chargeTaxAmount', width: 150,
        cellRenderer: (params) => {
          return params.value === 0 ? '' : index.formatNumberToThousands(params.value, 2)
        } },
      { headerName: this.$t('Payment.taxRate'), field: 'chargeTaxRate', width: 150,
        cellRenderer: (params) => {
          return params.value === 0 ? '' : index.formatNumberToThousands(params.value, 2)
        } },
      {
        headerName: this.$t('Billing.billingJob_billNo'),
        field: 'billingNo',
        colId: 'billingNo',
        width: 100
      },
      { headerName: this.$t('Payment.chargeRemark'), field: 'chargeRemarks', width: 200 },
      { headerName: 'ATD', field: 'jobAtd', width: 120,
        cellRenderer: (params) => {
          return ColumnUtils.dateLabelFunc(params.value)
        }
      },
      { headerName: 'ATA', field: 'jobAta', width: 120,
        cellRenderer: (params) => {
          return ColumnUtils.dateLabelFunc(params.value)
        }
      }, {
        headerName: this.$t('FinanceManage.charge_payReceiveDate'),
        colId: 'chargePayReceiveDate',
        field: 'chargePayReceiveDate',
        width: 180,
        valueFormatter: params => {
          return DateUtils.formatStandardDate(params.value)
        }
      }, {
        headerName: this.$t('FinanceManage.charge_writeOffDate'),
        colId: 'chargeClearingDate',
        field: 'chargeClearingDate',
        width: 180,
        valueFormatter: params => {
          return DateUtils.formatStandardDate(params.value)
        }
      }
    ]
  },
  beforeMount() {
    const context = this
    this.documentManage.set('toSearchTemplate', function(value) {
      context.toSearchTemplate(value)
    })
    this.loadData()
  },
  methods: {
    // 装载初始化数据
    loadData() {
      if (this.billPaymentUuid !== undefined && this.billPaymentUuid !== '') {
        this.queryBody.billPaymentUuid = this.billPaymentUuid
        queryBillPaymentDetail(this.queryBody).then(res => {
          this.billPayment = res.data
          this.billPayment.rate = NumberUtils.formatRoundNumber(this.billPayment.rate, 8)
          this.billPayment.amount = NumberUtils.formatRoundNumber(this.billPayment.amount, 2)
          if (this.billPayment.settlementAgentId === 0) {
            this.billPayment.settlementAgentId = ''
          } else {
            this.agentChecked = '1'
          }
          this.rowData = res.data.charges
          this.checkedCharges = lodash.cloneDeep(this.rowData)
          if (res.data.state === 0) {
            this.saveDisabled = false
            this.innerParamsFinal = 0
            this.canEditAgent = false
          } else {
            this.saveDisabled = true
            this.innerParamsFinal = 1
            this.canEditAgent = true
          }
          this.billPaymentChanged()
        })
      } else {
        console.log(this.paramsCharges)
        // 组装显示费用数据
        this.builDetailForCreate(this.paramsCharges)
      }
    },
    billPaymentAccountCallBack(item) {
      console.log(item)
      return item
    },
    /**
     * 添加费用
     */
    addCharge() {
      this.joinCharge.addChargeCondition.accountId = this.billPayment.accountId
      this.joinCharge.addChargeCondition.hasBillPayment = 0
      this.joinCharge.addChargeCondition.isShowWriteOff = 0
      // this.joinCharge.addChargeCondition.isAr = 0
      this.joinCharge.addChargeCondition.jobStates = [0, 1, 2, 3, 11]
      this.joinCharge.addChargeCondition.chargeStates = [0, 1, 2]
      this.joinCharge.addChargeCondition.confirmStates = [0, 1]
      this.joinCharge.addChargeCondition.exceptKeys = this.getExceptChargeKeys()
      this.joinCharge.visible = true
    },
    /**
     * 获取过滤费用列表
     */
    getExceptChargeKeys() {
      const keys = []
      for (let i = 0; i < this.rowData.length; i++) {
        keys.push(this.rowData[i].uuid)
      }
      return keys
    },
    /**
     *  组装展示费用
     */
    builDetailForCreate(chargeRows) {
      // this.billPayment.state = 0
      this.saveDisabled = false
      this.canEditAgent = true
      if (this.chargesDirty) {
        this.rowData = chargeRows
        this.chargesChanged()
      }
    },
    /**
     * 打印
     */
    toPrint() {
      // todo: confirm value
      // this.toSearchTemplate()
      this.$nextTick(async() => {
        // 每个页签的参数
        const params = {}
        params.category = 'BILLPAYMENT'
        // 公共参数
        params.BILLPAYMENT_UUID = this.billPaymentUuid
        params.BILL_PAYMENT_UUID = this.billPaymentUuid
        params.classNameType = SystemConstants.ACT
        console.log('---params--', params)
        this.templateSelectorDialog.ctx = new BillPayment(this.billPayment)
        this.templateSelectorDialog.category = params.category
        this.templateSelectorDialog.data = params
        // 组装打印回调函数
        await this.onPrintCallback()
        this.templateSelectorDialog.visible = true
      })
    },
    toPreStep() {
      this.$emit('toPreStep')
    },
    cancel(from) {
      this.$emit('cancel', { from: from, billPayment: this.billPayment })
    },
    // 【业务编号】列单元格中搜索图标点击触发事件
    toSearchTemplate(value) {
      // todo: 需要根据value装配this.templateSelectorDialog中相关内容
      const self = this
      if (!value) {
        self.$message.warning(`没有找到${value}对应的打印模板`)
      } else {
        this.templateSelectorDialog.data.JOB_UUID = [value]
        this.templateSelectorDialog.visible = true
      }
    },
    setBillPaymentSelectValue(obj) {
      this.billPayment[obj.key] = obj.value
    },
    // 开户银行回调事件
    getBankCusFromChild(obj) {
      this.billPayment.buyerBank = obj.bank
      this.billPayment.buyerBankAccount = obj.bankAccount
      this.buyerBankUuid = obj.uuid
    },
    // 保存
    async doSave() {
      console.log(this.billPayment)
      if (!this.billPayment.currency || this.billPayment.currency === '') {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectCurrency'))
        return
      }
      if (this.rowData.length === 0) {
        this.$message.warning(this.$t('Message.PleaseAddCosts'))
        return
      }
      if (!this.billPayment.deadline || this.billPayment.deadline === '') {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseEnterPaymentTerm'))
        return
      }
      if (this.openSapConfig && (!this.billPayment.settleDepartmentPrefix || this.billPayment.settleDepartmentPrefix === '')) {
        this.$message.warning(this.$t('CargoMsg.Cargo_DepartmentPrefixNotSelected'))
        return
      }
      const amount = NumberUtils.parseNumber(this.billPayment.amount, 2)
      const bmount = await this.getTexAmount()
      const cAmount = await NumberUtils.roundHalfUp3(bmount, 2)
      if (amount !== cAmount) {
        this.$message.warning(this.$t('Message.ApplicationAmountCheck'))
        return
      }

      if (!this.billPayment.settlementAgentId || this.billPayment.settlementAgentId === '') {
        this.billPayment.settlementAgentId = 0
      }
      let checkBranch = true
      let checkBranchId = true
      if (this.rowData.length > 0) {
        if (this.billPayment.branchId > 0) {
          checkBranchId = await SecurityUtil.checkChargeDetailBranch(this.billPayment.branchId)
        }
        for (let j = 0; j < this.rowData.length; j++) {
          checkBranch = await SecurityUtil.checkChargeDetailBranch(this.rowData[j].chargeBranchId)
          if (!checkBranch) {
            break
          }
        }
        if (!checkBranch && !checkBranchId) {
          this.$message.warning(this.$t('Message.CheckChargeDetailBranch'))
          return
        }
      }
      this.billPayment.branchId = this.$store.getters.currentOfficeId
      this.billPayment.singleRateView = true
      delete this.billPayment.currencyRateMap
      if (this.billPayment.uuid === '') { // 新增
        this.billPayment.jobNo = ''
        this.billPayment.costInvoiceNo = ''
        this.billPayment.customerId = -1
        this.billPayment.inputBy = this.$store.getters.userInfo.userId
        for (let i = 0; i < this.rowData.length; i++) {
          this.addChargeItem(this.rowData[i])
        }
        this.billPayment.params.isCheck = Number(this.context.config.get('isCheckBillPaymentAmount'))
        this.billPayment.params.otherCurrency = this.otherCurrencys[0]
        this.billPayment.params.txtRate = this.billPayment.rate
        this.billPayment.location = this.location
        createBillPayment(this.billPayment).then(res => {
          this.billPayment = { ...res.data }
          this.$message.success('保存成功')
          this.cancel(3)
        })
      } else { // 更新
        console.log('update billPayment')
        const commitBillPayment = lodash.cloneDeep(this.billPayment)
        for (let i = 0; i < this.rowData.length; i++) {
          if (this.rowData[i].billPaymentUuid === '') {
            const map = {}
            map.uuid = this.rowData[i].uuid
            map.version = this.rowData[i].version
            map.billPaymentUuid = this.rowData[i].billPaymentUuid
            if (commitBillPayment.chargesAdded === '') {
              const addCharge = []
              addCharge.push(map)
              commitBillPayment.chargesAdded = addCharge
            } else {
              commitBillPayment.chargesAdded.push(map)
            }
          }
        }
        delete commitBillPayment.mapCharge
        delete commitBillPayment.params
        delete commitBillPayment.charges
        if (commitBillPayment.chargesAdded === '') {
          delete commitBillPayment.chargesAdded
        }
        if (commitBillPayment.chargesRemoved === '') {
          delete commitBillPayment.chargesRemoved
        }
        commitBillPayment.location = this.location
        updateBillPayment(commitBillPayment).then(res => {
          this.billPayment = { ...res.data }
          this.$message.success('更新成功')
          this.cancel(3)
        })
      }
    },
    // addChargeItem
    addChargeItem(charge) {
      console.log('addChargeItem  charge = ', charge)
      const map = {}
      map.uuid = charge.uuid
      map.version = charge.version
      this.billPayment.mapCharge.push(map)
      // this.billPayment.isAdvance = charge.chargeAdvance
      this.billPayment.accountId = charge.chargeAccountId
      if (this.billPayment.jobNo === '') {
        this.billPayment.jobNo = charge.jobJobNo
      } else if (this.billPayment.jobNo !== charge.jobJobNo) {
        this.billPayment.jobNo = ''
      }
      if (this.billPayment.costInvoiceNo === '' && charge.chargeInvoiceNo !== null && charge.chargeInvoiceNo !== '') {
        this.billPayment.costInvoiceNo = charge.chargeInvoiceNo
      } else if (this.billPayment.costInvoiceNo !== charge.chargeInvoiceNo && charge.chargeInvoiceNo !== null && charge.chargeInvoiceNo !== '') {
        this.billPayment.costInvoiceNo = ''
      }
      if (Number('-1') === Number(this.billPayment.customerId)) {
        this.billPayment.customerId = charge.jobCustomerId
      } else if (this.billPayment.customerId > 0 && this.billPayment.customerId !== charge.jobCustomerId) {
        this.billPayment.customerId = 0
      }
    },
    // 移除费用操作
    removeCahrge() {
      const chooseRows = getGridSelected(this.gridOptions)
      console.log(chooseRows)
      if (chooseRows.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectExpense'))
        return
      }
      this.$confirm(this.$t('CargoMsg.Cargo_SureToRemoveTheExpenseItem', [chooseRows.length]), '提示', {
        dangerouslyUseHTMLString: true,
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const rowData = this.rowData
        for (let i = 0; i < chooseRows.length; i++) {
          const selectItem = chooseRows[i]
          const index = rowData.indexOf(selectItem)
          if (index > -1) {
            rowData.splice(index, 1)
            if (selectItem.billPaymentUuid !== '') {
              const charge = {}
              charge.uuid = selectItem.uuid
              charge.version = selectItem.version
              charge.billPaymentUuid = selectItem.billPaymentUuid
              if (this.billPayment.chargesRemoved === '') {
                const removedChargeArray = []
                removedChargeArray.push(selectItem)
                this.billPayment.chargesRemoved = removedChargeArray
              } else {
                this.billPayment.chargesRemoved.push(selectItem)
              }
            }
            this.currencyChangeHandler()
            this.billPayment.currencyAmount = this.calCurrencyAmount()
          }
        }
        this.$message.success('移除成功')
        console.log(this.billPayment)
      }).catch((e) => {
        console.log(e)
        return Promise.reject('移除已取消')
      })
    },
    // 费用改变事件
    async chargesChanged() {
      if (this.rowData === null || this.rowData.length === 0) {
        console.log(' rowData is null return')
        return
      }
      this.ywTypeList = []
      for (let i = 0; i < this.rowData.length; i++) {
        // 组装业务类型
        if (SystemConstants.SE.code === this.rowData[i].jobLob) {
          this.billPayment.ywType = 1
          this.billPayment.se = true
          this.ywTypeList.push('SE')
        } else if (SystemConstants.SI.code === this.rowData[i].jobLob) {
          this.billPayment.ywType = 2
          this.billPayment.si = true
          this.ywTypeList.push('SI')
        } else if (SystemConstants.AE.code === this.rowData[i].jobLob) {
          this.billPayment.ywType = 3
          this.billPayment.ae = true
          this.ywTypeList.push('AE')
        } else if (SystemConstants.AI.code === this.rowData[i].jobLob) {
          this.billPayment.ywType = 4
          this.billPayment.ai = true
          this.ywTypeList.push('AI')
        }
      }
      const charge = this.rowData[0]
      // 申请人
      this.billPayment.inputBy = this.$store.getters.userInfo.userId
      // 申请时间
      this.billPayment.inputDate = new Date()
      // 结算对象
      this.billPayment.accountId = charge.chargeAccountId
      // 获取当前结算对象
      this.company = await Company.getCompanyById(charge.chargeAccountId)
      await this.changedAccount()
      // 币种
      this.billPayment.currency = charge.chargeCurrency
      this.currencyChangeHandler()
      // isNewInstance 新增付款申请时
      if (this.billPaymentUuid === '' || this.billPaymentUuid === undefined) {
        const map = {}
        let currentAmount = ''
        for (let i = 0; i < this.rowData.length; i++) {
          const newCharge = { ...this.rowData[i] }
          newCharge.isSelect = false
          newCharge.key = this.rowData[i].chargeId
          // newCharge.version = this.rowData[i].chargeversion  todo
          newCharge.amount = this.rowData[i].chargeAmount
          newCharge.currency = this.rowData[i].chargeCurrency
          // 针对于分单币种新字段，老数据需要在查看账单明细并对其进行操作时计算该字段的值
          if (!newCharge.chargeReceivable) {
            if (!map.hasOwnProperty(newCharge.chargeCurrency)) {
              map[newCharge.chargeCurrency] = newCharge.chargeAmount
            } else {
              map[newCharge.chargeCurrency] += newCharge.chargeAmount
            }
          } else {
            if (!map.hasOwnProperty(newCharge.chargeCurrency)) {
              map[newCharge.chargeCurrency] = -newCharge.chargeAmount
            } else {
              map[newCharge.chargeCurrency] -= newCharge.chargeAmount
            }
          }
        }

        for (const curreny in map) {
          currentAmount += curreny + ':' + NumberUtils.formatNumber(map[curreny], 2) + ';'
        }
        this.billPayment.currencyAmount = currentAmount
        this.refreshTotal()
      }
    },
    // 付款申请改变事件
    async billPaymentChanged() {
      // 状态
      if (this.billPayment.state === 0) {
        this.canEditAgent = false
      }
      // 业务类型
      this.ywTypeList = []
      if (this.billPayment.se === true) {
        this.ywTypeList.push('SE')
      }
      if (this.billPayment.si === true) {
        this.ywTypeList.push('SI')
      }
      if (this.billPayment.ae === true) {
        this.ywTypeList.push('AE')
      }
      if (this.billPayment.ai === true) {
        this.ywTypeList.push('AI')
      }
      console.log(this.ywTypeList)
      // 获取当前结算对象
      this.company = await Company.getCompanyById(this.billPayment.accountId)
      if (this.billPayment.settlementAgentId && this.billPayment.settlementAgentId !== '' && this.billPayment.settlementAgentId !== 0) {
        this.settlementAgent = await Company.getCompanyById(this.billPayment.settlementAgentId)
      }
      // 加载结算代理
      this.changedAccount()
    },
    currencyExchanged(item) {
      this.billPayment.currency = item.value
      this.currencyChangeHandler()
      return item.value
    },
    // 汇率改变事件chargesAdded
    currencyChangeHandler() {
      const currency = this.billPayment.currency
      this.otherCurrencys = []
      for (let i = 0; i < this.rowData.length; i++) {
        if (this.rowData[i].chargeCurrency !== currency && this.otherCurrencys.indexOf(this.rowData[i].chargeCurrency) === -1) {
          this.otherCurrencys.push(this.rowData[i].chargeCurrency)
        }
      }
      if (this.otherCurrencys.length > 0) {
        // 改变汇率标签 todo
        const rate = RateUtil.getForeignExchangeRateSafely(currency, this.otherCurrencys[0], new Date(), this.billPayment.branchId)
        this.billPayment.rate = NumberUtils.formatRoundNumber(rate, 8)
        this.rateTitle = this.otherCurrencys[0] + this.$t('Payment.exchangeRate')
      } else {
        this.billPayment.rate = 1.000000
        this.rateTitle = this.$t('Payment.exchangeRate')
      }
      this.refreshAmount()
    },
    // 刷新金额
    async refreshAmount() {
      const amount = await this.getTexAmount()
      this.billPayment.amount = NumberUtils.formatRoundNumber(amount, 2)
      this.refreshTotal()
    },
    // 单独修改汇率事件
    rateChangeHandler() {
      this.refreshAmount()
    },
    // 刷新金额
    async getTexAmount() {
      let amount = 0
      // CARGO-38807 H5 BUG 销账/付款申请单界面金额合计显示错误 付款金额
      const amountCurrencys = ChargeUtils.getZeroAmountCurrencys(this.rowData, 'chargeCurrency', 'chargeAmount', 'chargeReceivable')
      for (let i = 0; i < this.rowData.length; i++) {
        if (amountCurrencys.includes(this.rowData[i].chargeCurrency)) continue
        let rate = 1
        if (this.rowData[i].chargeCurrency === this.billPayment.currency) {
          rate = 1
        } else if (this.rowData[i].chargeCurrency === this.otherCurrencys[0]) {
          rate = this.billPayment.rate
        } else {
          rate = await RateUtil.getForeignExchangeRateSafely(this.billPayment.currency, this.rowData[i].chargeCurrency, new Date(), this.billPayment.branchId)
        }
        this.chargeRate = rate
        if (this.rowData[i].chargeReceivable) {
          // amount -= this.rowData[i].chargeAmount * rate
          amount -= RateUtil.getAmountByCurrency(NumberUtils.ToFixed2(this.rowData[i].chargeAmount * rate, 2), this.billPayment.currency)
        } else {
          // amount += this.rowData[i].chargeAmount * rate
          amount += RateUtil.getAmountByCurrency(NumberUtils.ToFixed2(this.rowData[i].chargeAmount * rate, 2), this.billPayment.currency)
        }
      }
      console.log('return amount =>', amount)
      // return amount
      return RateUtil.getAmountByCurrency(NumberUtils.ToFixed2(amount, 2), this.billPayment.currency)
    },
    // 更新合计
    refreshTotal() {
    },
    // 不知道干嘛的 加载结算代理
    async changedAccount() {
      console.log('company  ===', this.company)
      if (this.company !== '' && this.company.settlementAgents === '') {
        getSettlementAgentsByCmpIdx(this.company.cmpIdx).then(res => {
          this.company.settlementAgents = res.data
          this.loadSettlementAgentsResultHandler()
        })
      } else {
        this.loadSettlementAgentsResultHandler()
      }
    },
    // 不知道干嘛的 渲染计算代理数据源
    async loadSettlementAgentsResultHandler() {
      console.log('company.settlementAgents === ', this.company.settlementAgents)
      if (this.company !== '' && this.company.settlementAgents !== undefined && this.company.settlementAgents !== '' && this.company.settlementAgents.length > 0) {
        // 改变结算代理数据源
        this.settlementAgentList = this.company.settlementAgents
        // 改变按钮可编辑
        // this.canEditAgent = false
        // 查找计算代理银行
        if (this.agentChecked === '1' && this.settlementAgent !== '') {
          for (let i = 0; i < this.settlementAgentList.length; i++) {
            if (this.settlementAgent.cmpIdx === this.settlementAgentList[i].cmpIdx) {
              this.billPayment.settlementAgentId = this.settlementAgent.cmpIdx
              allTitleBanksByCmpIdx(this.settlementAgent.cmpIdx).then(res => {
                if (this.billPayment.uuid === '') {
                  this.queryTitleBankSuccessHandler(res.data)
                } else {
                  this.queryTitleBankSuccessHandler2(res.data)
                }
              })
            }
          }
        } else {
          this.billPayment.settlementAgentId = ''
          allTitleBanksByCmpIdx(this.company.cmpIdx).then(res => {
            this.queryTitleBankSuccessHandler(res.data)
          })
        }
      } else {
        this.canEditAgent = true
        this.canEditAgentBox = true
        this.settlementAgentList = []
      }
    },
    // 结算代理checkbox change事件handler
    cbSettlementAgentChangeHandler() {
      console.log(' change select Agent function')
      if (this.canEditAgent === false && this.agentChecked === '1') {
        this.canEditAgentBox = false
        this.ddlSettlementAgentChangeHandler()
      } else {
        this.canEditAgentBox = true
        this.txtAccountIdChangeHandler()
      }
    },
    /**
     * 结算对象 change事件handler
     * @param event
     */
    async txtAccountIdChangeHandler() {
      this.company = await Company.getCompanyById(this.billPayment.accountId)
      if (this.company !== '' && this.company.cmpIdx !== undefined && this.company.cmpIdx !== '') {
        if (this.agentChecked === '0') {
          allTitleBanksByCmpIdx(this.company.cmpIdx).then(res => {
            this.queryTitleBankSuccessHandler(res.data)
          })
        }
      }
    },
    // 结算代理下拉框选择结算代理 查询结算代理开户银行
    ddlSettlementAgentChangeHandler() {
      if (this.agentChecked === '1' && this.billPayment.settlementAgentId !== '') {
        console.log('billpaymebt.settlementAgentId  ==== ', this.billPayment.settlementAgentId)
        allTitleBanksByCmpIdx(this.billPayment.settlementAgentId).then(res => {
          this.queryTitleBankSuccessHandler(res.data)
        })
      }
    },
    // 渲染开户行下拉框数据
    queryTitleBankSuccessHandler(data) {
      console.log('titleBankArray ====', data)
      this.titleBankArray = data
      let flag = false
      // CARGO-1138 付款申请未提交无法修改银行信息
      if (this.titleBankArray === null || this.titleBankArray === '') {
        this.titleBankArray = []
      }
      if (!this.titleBankArray.find(item => item.bank === this.billPayment.buyerBank && item.bankAccount === this.billPayment.buyerBankAccount)) {
        this.titleBankArray.push({ bank: this.billPayment.buyerBank, uuid: this.billPayment.uuid, bankAccount: this.billPayment.buyerBankAccount, currency: this.billPayment.currency })
      }
      if (!this.billPayment.uuid) {
        if (this.titleBankArray.length > 0) {
          for (let i = 0; i < this.titleBankArray.length; i++) {
            if (this.titleBankArray[i].defaultBank === true) {
              this.billPayment.buyerBank = this.titleBankArray[i].bank
              this.billPayment.buyerBankAccount = this.titleBankArray[i].bankAccount
              this.buyerBankUuid = this.titleBankArray[i].uuid
              flag = true
              break
            }
          }
        }
      } else {
        this.buyerBankUuid = ''
        for (const titleBank of this.titleBankArray) {
          if (titleBank.bank === this.billPayment.buyerBank && titleBank.bankAccount === this.billPayment.buyerBankAccount) {
            this.buyerBankUuid = titleBank['uuid']
            break
          }
        }
        flag = true
      }
      if (!flag) {
        this.billPayment.buyerBank = ''
        this.billPayment.buyerBankAccount = ''
        this.buyerBankUuid = ''
      }
    },
    // 不刷新银行选择内容，只更新数据源
    queryTitleBankSuccessHandler2(data) {
      this.titleBankArray = data
    },
    // 添加费用确定回掉 rows 选择的费用
    addChargeCallBackEvent(rows) {
      console.log('choses add  charges = ', rows)
      this.joinCharge.visible = false
      if (rows && rows.length > 0) {
        for (let i = 0; i < rows.length; i++) {
          if (this.billPayment.chargesRemoved.length !== '' && this.billPayment.chargesRemoved.length > 0) {
            for (let j = 0; j < this.billPayment.chargesRemoved.length; j++) {
              if (rows[i].uuid === this.billPayment.chargesRemoved[j].uuid) {
                this.billPayment.chargesRemoved.splice(j, 1)
              }
            }
          }
          this.rowData.push(rows[i])
        }
        this.currencyChangeHandler()
        this.billPayment.currencyAmount = this.calCurrencyAmount()
      }
    },
    // 计算分币种合计
    calCurrencyAmount() {
      const map = {}
      let currentAmount = ''
      for (let i = 0; i < this.rowData.length; i++) {
        const newCharge = { ...this.rowData[i] }
        newCharge.isSelect = false
        newCharge.key = this.rowData[i].chargeId
        newCharge.amount = this.rowData[i].chargeAmount
        newCharge.currency = this.rowData[i].chargeCurrency
        // 针对于分单币种新字段，老数据需要在查看账单明细并对其进行操作时计算该字段的值
        if (!newCharge.chargeReceivable) {
          if (!map.hasOwnProperty(newCharge.chargeCurrency)) {
            map[newCharge.chargeCurrency] = newCharge.chargeAmount
          } else {
            map[newCharge.chargeCurrency] += newCharge.chargeAmount
            map[newCharge.chargeCurrency] = RateUtil.getAmountByCurrency(amount, newCharge.chargeCurrency)
          }
        } else {
          if (!map.hasOwnProperty(newCharge.chargeCurrency)) {
            map[newCharge.chargeCurrency] = -newCharge.chargeAmount
          } else {
            map[newCharge.chargeCurrency] -= newCharge.chargeAmount
            map[newCharge.chargeCurrency] = RateUtil.getAmountByCurrency(amount, newCharge.chargeCurrency)
          }
        }
      }
      for (const curreny in map) {
        // currentAmount += curreny + ':' + NumberUtils.formatRoundNumber(map[curreny], 2) + ';'
        currentAmount += curreny + ':' + NumberUtils.formatRoundNumber(RateUtil.getAmountByCurrency(map[curreny], curreny), 2) + ';'
      }
      return currentAmount
    },
    // 提交付款申请
    commit() {
      this.canSendWeaver = true
      const billPayment = {
        state: 1,
        inputDate: this.billPayment.inputDate,
        currency: this.billPayment.currency,
        billPayments: []
      }
      const selectItem = {}
      selectItem.version = this.billPayment.version
      selectItem.uuid = this.billPayment.uuid
      billPayment.billPayments.push(selectItem)
      // batchUpdateBilPaymentState(billPayment).then(res => {
      //   if (res.data === 0) {
      //     this.$message.warning(this.$t('CargoMsg.Cargo_OperationFailed'))
      //     this.canSendWeaver = false
      //   } else {
      //     this.$message.success(this.$t('CargoMsg.Cargo_OperationComplete'))
      //     this.cancel(3)
      //     this.loadData()
      //   }
      // }).catch(() => {
      //   this.canSendWeaver = false
      // })
      batchUpdateBilPaymentStatePrintMsg(billPayment).then(res => {
        if (res.data.code === 0) {
          this.$message.warning(res.data.msg)
          this.canSendWeaver = false
        } else {
          this.$message.success(res.data.msg)
          this.cancel(3)
          this.loadData()
        }
      }).catch(() => {
        this.canSendWeaver = false
      })
    },
    onPrintCallback() {
      console.log('printcallback')
    }
  }
}
</script>

<style lang="scss">
</style>
